import { UpdatePlayerInputDto } from '@/services/dto/players/update-player-input.dto';
import { Button, Input } from '@starsoft/common/components';
import { useFormContext } from 'react-hook-form';
import { UpdateUsernameFormProps } from './props';
import useTranslation from 'next-translate/useTranslation';
import styles from './styles.module.scss';

export function UpdateUsernameForm({
  isPending,
  back,
}: UpdateUsernameFormProps) {
  const { t } = useTranslation('common');
  const { register, watch } = useFormContext<UpdatePlayerInputDto>();
  const username: string = watch('username');

  return (
    <div className={styles.container}>
      <Input name="username" register={register} />

      <div className={styles.container__row}>
        <Button type="button" isSecondary onClick={back}>
          {t('back_button')}
        </Button>
        <Button isloading={isPending} disabled={!username} type="submit">
          {t('save')}
        </Button>
      </div>
    </div>
  );
}
